export default __webpack_public_path__ + "static/media/profileDarrell.3149f450.png";